const messageConfig = require('@/models/messageConfig.js');
const convertDecimal = require('@/assets/js/convert').convertDecimal;
const Number_Validation = (rule, value) => {
  return parseFloat(value) !== 'NaN' && !isNaN(value);
};

// 附加率非空验证
const loadingValidator = (rule, value, callback, source) => {
  const bValidate = value !== '';

  if (!bValidate) {
    source.loading = 0;
  }

  return bValidate;
};

// 媒体总费用非空验证
const nettItemSumValidator = (rule, value, callback, source) => {
  const bValidate = value !== '';
  if (!bValidate) {
    source.nettItemSum = 0;
  }

  return bValidate;
};

// 媒体费用非空验证
const mediaTotalInternalSplitValidator = (rule, value, callback, source) => {
  const bValidate = value !== '';
  if (!bValidate) {
    source.mediaTotalInternalSplit = 0;
  }

  return bValidate;
};

// 制作SA非空验证
const productionTotalInternalSplitValidator = (
  rule,
  value,
  callback,
  source
) => {
  const bValidate = value !== '';
  if (!bValidate) {
    source.productionTotalInternalSplit = 0;
  }

  return bValidate;
};

// 服务费非空验证
const serviceFeeSplitValidator = (rule, value, callback, source) => {
  const bValidate = value !== '';
  if (!bValidate) {
    source.serviceFee = 0;
  }

  return bValidate;
};

// 制作费用类型自定义验证
const ProductionCostTypeValidation = (rule, value, callback, source) => {
  return (
    convertDecimal(source.piCost) === 0 ||
    (convertDecimal(source.piCost) > 0 && (value || '') !== '')
  );
};

// 费用自定义验证
const ContractCostValidation = (rule, value, callback, source) => {
  if ((source.action || '') === '') {
    return true;
  }

  const storeJs = require('@/store/internalsplit.js').useInternalSplitStore();
  var Cost = 0;

  if ((storeJs.ContractSplitMedias?.length || 0) > 0) {
    if (rule.fullField === 'salesServiceFee') {
      Cost = storeJs.ContractSplitMedias.map((t) =>
        convertDecimal(t.serviceFee || 0)
      ).reduce((pre, curr) => pre + curr);
    } else if (rule.fullField === 'mediaNett') {
      Cost = storeJs.ContractSplitMedias.map((t) =>
        convertDecimal(t.nettItemSum || 0)
      ).reduce((pre, curr) => pre + curr);
    }
  }

  return convertDecimal(value) === convertDecimal(Cost);
};

// 服务费用类型非空验证
const SalesServiceTypeValidation = (rule, value, callback, source) => {
  return (
    convertDecimal(source.salesServiceFee) === 0 ||
    (convertDecimal(source.salesServiceFee) > 0 && (value || '') !== '')
  );
};

// 预付制作费用结束日期非空验证
const AdditionalEndDateValidation = (rule, value, callback, source) => {
  return (
    convertDecimal(source.additionalProduction) === 0 ||
    (convertDecimal(source.additionalProduction) > 0 && (value || '') !== '')
  );
};

// 特殊佣金安排自定义验证
const SpecialComValidation = (rule, value, callback, source) => {
  if ((source.mediaCost || '') === '' && (source.productionCost || '') === '') {
    return true;
  }

  const storeJs = require('@/store/internalsplit.js').useInternalSplitStore();
  const splitMedia = storeJs.ContractSplitMedias.find(
    (t) => t.splitMediaId === source.splitMediaId
  );

  const mediasum =
    convertDecimal(splitMedia?.nettItemSum || 0) +
    convertDecimal(splitMedia?.totalProductionCost || 0);
  const commissionsum =
    convertDecimal(source.mediaCost) + convertDecimal(source.productionCost);
  return mediasum === commissionsum;
};

module.exports = {
  contractSplitMediaRules: {
    dates: {
      required: true,
      type: 'array',
      message: messageConfig.getMessage('validformrequire'),
    },
    loading: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator: loadingValidator,
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
    nettItemSum: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator: nettItemSumValidator,
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
    unitProductionCost: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator(rule, value, callback, source) {
          if (source.category !== 'Bus Shelter') {
            const bValidate = value !== '';
            if (!bValidate) {
              source.unitProductionCost = 0;
            }

            return bValidate;
          }
          return true;
        },
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
    totalProductionCost: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator(rule, value, callback, source) {
          const bValidate = value !== '';
          if (!bValidate) {
            source.totalProductionCost = 0;
          }

          return bValidate;
        },
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
    mediaTotalInternalSplit: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator: mediaTotalInternalSplitValidator,
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
    productionTotalInternalSplit: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator: productionTotalInternalSplitValidator,
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
    serviceFee: [
      {
        require: true,
        message: messageConfig.getMessage('errornumber'),
        validator: serviceFeeSplitValidator,
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator: Number_Validation,
      },
    ],
  },
  contractSplitRules: {
    mediaNett: [
      {
        required: true,
        validator(rule, value, callback, source) {
          if (!value) {
            source.mediaNett = 0;
          }
          return true;
        },
      },
      {
        message: messageConfig.getMessage('errornumber'),
        validator(rule, value, callback, source) {
          const bValidate = Number_Validation(rule, value);
          if (!bValidate) {
            source.mediaNett = 0;
          }

          return bValidate;
        },
      },
      {
        message: messageConfig.getMessage('validmedianett'),
        validator: ContractCostValidation,
      },
    ],
    productionCostType: {
      message: messageConfig.getMessage('validformrequire'),
      validator: ProductionCostTypeValidation,
    },
    salesServiceFee: [
      {
        message: messageConfig.getMessage('errornumber'),
        validator(rule, value, callback, source) {
          const bValidate = Number_Validation(rule, value);
          if (!bValidate) {
            source.salesServiceFee = 0;
          }

          return bValidate;
        },
      },
      {
        message: messageConfig.getMessage('validservicefee'),
        validator: ContractCostValidation,
      },
    ],
    salesServiceType: {
      message: messageConfig.getMessage('validformrequire'),
      validator: SalesServiceTypeValidation,
    },
    additionalProduction: {
      message: messageConfig.getMessage('errornumber'),
      validator(rule, value, callback, source) {
        const bValidate = Number_Validation(rule, value);
        if (!bValidate) {
          source.additionalProduction = 0;
        }

        return bValidate;
      },
    },
    additionalProductionEndDate: {
      message: messageConfig.getMessage('validformrequire'),
      validator: AdditionalEndDateValidation,
    },
    specialDiscountAmount: [
      {
        required: true,
        message: messageConfig.getMessage('errornumber'),
        validator(rule, value, callback, source) {
          const bValidate = Number_Validation(rule, value);
          if (!bValidate) {
            source.specialDiscountAmount = 0;
          }

          return bValidate;
        },
      },
      {
        message:
          'Special Discount cannot greater than the Contract Media Amount.',
        validator(rule, value, callback, source) {
          var SpecialDiscount = parseFloat(value);
          if (SpecialDiscount === 0) {
            return true;
          }

          var contractMediaAmount = parseFloat(source.mediaNett);

          return SpecialDiscount < contractMediaAmount;
        },
      },
    ],
    specialDiscountDesc: {
      message: messageConfig.getMessage('validformrequire'),
      validator(rule, value, callback, source) {
        if (source.specialDiscountAmount && !value) {
          return false;
        }
        return true;
      },
    },
    mediaSize: {
      message: 'Please complete previous steps first.',
      validator(rule, value) {
        console.log('mediaSize', value);
        if (!value || value?.toString() === '0') {
          console.log('false');
          return false;
        }
        console.log('true');
        return true;
      },
    },
  },
  specialCommissionRules: {
    mediaCost: {
      message: messageConfig.getMessage('errornumber'),
      validator(rule, value, callback, source) {
        value = parseFloat(value) || '';

        if ((source.productionCost || '') === '' && value === '') {
          return true;
        }

        const bValidate = Number_Validation(rule, value);

        return bValidate;
      },
    },
    productionCost: {
      message: messageConfig.getMessage('errornumber'),
      validator(rule, value, callback, source) {
        value = parseFloat(value) || '';

        if ((source.mediaCost || '') === '' && value === '') {
          return true;
        }

        const bValidate = Number_Validation(rule, value);

        return bValidate;
      },
    },
    totalCost: {
      message: messageConfig.getMessage('commissionnomatch'),
      validator: SpecialComValidation,
    },
  },
};
